export const WELCOME_DATA = {
  headline: 'Welcome to the Musical Explorers Around the World Map',
  text: 'Discover artists and musical traditions from around the world with fun and participatory activities for kids and families. Click on the pins to explore!',
};
